import { Router } from '@angular/router';
import { checkIfCodeTriggeredNavigation } from 'src/app/guards/session-guards-util';

// Router/history state that lets a page opt in to the side nav on routes that hide it by default.
export interface SideNavNavigationState {
  keepSideNav?: boolean;
}

// Back/forward replays the history entry's old state, so only honour state passed by an
// in-app navigation (same rule as the waiting-room / request-access guards).
export function getCodeTriggeredNavigationState<T>(router: Router): T | undefined {
  return checkIfCodeTriggeredNavigation(router)
    ? (router.getCurrentNavigation()?.extras.state as T | undefined)
    : undefined;
}
